import '@firebase/performance-compat';
//# sourceMappingURL=index.esm.js.map
